module.exports = __webpack_public_path__ + "static/img/img_08.c3a2dde7.png";